import { updateBet } from 'features/home/homeSlice';
import { MatchTimeResponse, OddsMessage } from 'models';
import { ComponentType, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { updateGameOdds, updateMatchTime } from 'redux/gameSlice';
import SockJS from 'sockjs-client';
import { Message, over } from 'stompjs';

const SUBCRIBE_ODDS_GATEWAY = `${process.env.REACT_APP_CHAT_ROOM_GATEWAY_URL}/ws`;

export const withLiveOddsUpdate = <P extends object>(WrappedComponent: ComponentType<P>) => {
  const WithLiveOddsUpdate: React.FC<P> = (props) => {
    const dispatch = useDispatch();

    const stompClient = useMemo(() => over(new SockJS(SUBCRIBE_ODDS_GATEWAY)), []);

    stompClient.debug = () => {};

    const connect = () => {
      stompClient.connect({}, onConnected, onError);
    };

    const onError = (error: any) => {
      console.log(error);
    };

    const onConnected = () => {
      stompClient.subscribe('/subscribe/odds', onMessageReceived);
    };

    const onMessageReceived = (payload: Message) => {
      if (payload) {
        const message: OddsMessage = JSON.parse(payload.body);

        if (message.type === 'ODDS') {
          dispatch(updateGameOdds(message));
          dispatch(updateBet(message.odds));
        }
        if (message.type === 'MATCH-TIME') {
          dispatch(updateMatchTime(JSON.parse(message.matchTime) as MatchTimeResponse));
        }
      }
    };

    useEffect(() => {
      connect();
      return () => {
        if (stompClient.connected) {
          stompClient.disconnect(() => {
            console.log('Disconnected from odds feed');
          });
        }
      };
    }, []);
    return <WrappedComponent {...props} />;
  };

  WithLiveOddsUpdate.displayName = `WithLiveOddsUpdate(${getDisplayName(WrappedComponent)})`;

  return WithLiveOddsUpdate;
};

function getDisplayName<P>(WrappedComponent: ComponentType<P>): string {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
